import React from 'react'
import ReactDOM from 'react-dom/client'

import './styles'
import App from './App'
import reportWebVitals from './reportWebVitals'
import { forcyteService } from './services'
import {
  extractAuthToken,
  extractChairpersonAuthToken,
  cleanUrlParams,
} from './utils/auth'

// Function to load DailyStory beacon with a tenant UID
const loadDailyStoryBeacon = tenantUid => {
  if (typeof window === 'undefined' || window._dsSettings) return

  if (!tenantUid) {
    console.warn('DailyStory tenant UID not available, skipping beacon load')
    return
  }

  ;(function (d, a, i) {
    d._dsSettings = i
    const r = a.createElement('script')
    const o = a.getElementsByTagName('script')[0]
    r.src = '//us-2.dailystory.com/ds/ds' + i + '.js'
    r.async = true
    r.id = 'ds-sitescript'
    o.parentNode.insertBefore(r, o)
  })(window, document, tenantUid)
}

// Fetch portal-config and initialize DailyStory before rendering React
const initializeApp = async () => {
  try {
    // Check for chairperson auth token first
    const chairpersonAuth = extractChairpersonAuthToken()
    if (chairpersonAuth.token && chairpersonAuth.tokenExpiry) {
      forcyteService.setToken(
        chairpersonAuth.token,
        chairpersonAuth.tokenExpiry
      )
    } else {
      // Check for donor auth token
      const donorAuth = extractAuthToken()
      if (donorAuth.token && donorAuth.tokenExpiry) {
        forcyteService.setToken(donorAuth.token, donorAuth.tokenExpiry)
      }
    }

    // Clean URL params after extracting tokens
    cleanUrlParams()

    // Fetch portal-config to get dailystory_tenant_uid
    const portalConfigResponse = await forcyteService.get(
      '/admin/portal-config'
    )
    const portalConfig = portalConfigResponse?.data
    const dailystoryTenantUid = portalConfig?.dailystory_tenant_uid

    // Load DailyStory beacon with the tenant UID from config
    if (dailystoryTenantUid) {
      loadDailyStoryBeacon(dailystoryTenantUid)
    } else {
      console.warn('DailyStory tenant UID not found in portal-config')
    }
  } catch (error) {
    console.error('Failed to initialize app (DailyStory may not load):', error)
  }

  // Render React app
  const root = ReactDOM.createRoot(document.getElementById('root'))
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  )
}

// Initialize and render
initializeApp()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
